import { useContext } from 'react';

import { TargetSelectorContext } from '@/contexts/TargetSelectorContextDefinition';

export function useTargetSelector() {
  const context = useContext(TargetSelectorContext);

  if (!context) {
    throw new Error('useTargetSelector must be used within a TargetSelectorProvider');
  }

  return context;
}
